/**
 * Created by asiulik on 30.11.2017.
 */

define(['jquery', './filterConfig'], function($, FilterConfig){

    function FilterPreloader($preloader){
        this.$preloader = $preloader;
    }

    FilterPreloader.prototype.showPreloader = function(){
        this.$preloader.addClass(FilterConfig.filterPreloaderActiveClass);
    };

    FilterPreloader.prototype.hidePreloader = function(){
        this.$preloader.removeClass(FilterConfig.filterPreloaderActiveClass);
    };

    return FilterPreloader;

});



// WEBPACK FOOTER //
// ./Private/Scripts/modules/filters/filterPreloader.js